import { throttle } from '@entando/utils';
import {
  SHOW_LOADING,
  HIDE_LOADING,
  SET_CONFIRM,
  SET_LOADING_MSG,
  SET_LOAD_TYPE,
  SHOW_ACTION_LOADING,
  HIDE_ACTION_LOADING,
} from './types';

export const showLoading = () => ({
  type: SHOW_LOADING,
});

export const setConfirmed = confirmed => ({
  type: SET_CONFIRM,
  payload: { confirmed },
});

export const setLoadType = (code = '') => ({
  type: SET_LOAD_TYPE,
  payload: { code },
});

export const hideLoading = delay => (dispatch) => {
  dispatch(setLoadType());
  const fxn = delay ? (
    new Promise(resolve => throttle(() => resolve()))
  ) : Promise.resolve();
  fxn.then(() => dispatch({ type: HIDE_LOADING }));
};

export const setLoadingMessage = message => ({
  type: SET_LOADING_MSG,
  payload: { message },
});

export const showLoadingWithMessage = message => (dispatch) => {
  dispatch(setLoadingMessage(message));
  dispatch(showLoading());
};

export const showActionLoading = () => ({
  type: SHOW_ACTION_LOADING,
});

export const hideActionLoading = delay => (dispatch) => {
  const fxn = delay ? (
    new Promise(resolve => throttle(() => resolve()))
  ) : Promise.resolve();
  fxn.then(() => dispatch({ type: HIDE_ACTION_LOADING }));
};
